import { render } from "./EconomicImpact.vue?vue&type=template&id=69ac45f8&scoped=true"
import script from "./EconomicImpact.vue?vue&type=script&lang=js"
export * from "./EconomicImpact.vue?vue&type=script&lang=js"

import "./EconomicImpact.vue?vue&type=style&index=0&id=69ac45f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69ac45f8"]])

export default __exports__